// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"93a17392","307":"9e2dc094","596":"b4110537","792":"c8cca127","859":"624a09f5","962":"822fd401"}[chunkId] + ".chunk.css";
};